import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { GridColumn, IFormHelperProps, ISuggestionItem, SuggestionField } from 'telia-front-react';
import { CallingCodeSuggestion } from '../../roaming/RoamingInterfaces';
import { useStores } from '../../stores/RootStore';
import { COUNTRY_CALLING_CODE_ID, helperInErrorState } from '../../util/FieldHelperUtil';

interface CountryCallingCodeProps {
  getHelper: () => IFormHelperProps | undefined;
  shouldValidate: boolean;
}

const CountryCallingCode = observer((props: CountryCallingCodeProps): React.JSX.Element => {
  const { countryCallingCodeStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const { getHelper, shouldValidate } = props;
  const [callingCodeHelper, setCallingCodeHelper] = React.useState<IFormHelperProps | undefined>(undefined);

  React.useEffect(() => {
    countryCallingCodeStore.subscribe();
    countryCallingCodeStore.initializeDefaultCountry();

    return () => {
      countryCallingCodeStore.unsubscribe();
    };
  }, []);

  React.useEffect(() => {
    setCallingCodeHelper(getHelper());
  }, [countryCallingCodeStore.callingCodeSuggestionSearchTerm, shouldValidate]);

  return (
    <GridColumn width={['xs-12', 'sm-6', 'md-5']}>
      <SuggestionField
        id={COUNTRY_CALLING_CODE_ID}
        label={translate('form.fields.countryCode')}
        items={countryCallingCodeStore.callingCodeSuggestionItems}
        value={countryCallingCodeStore.callingCodeSuggestionSearchTerm}
        image={countryCallingCodeStore.selectedCountryImage}
        input={{ autoComplete: 'off' }}
        isInvalid={helperInErrorState(callingCodeHelper)}
        onChange={(input: string) => countryCallingCodeStore.handleInputChange(input)}
        onSelect={(selectedItem: ISuggestionItem) => countryCallingCodeStore.selectCallingCodeSuggestionItem(selectedItem as CallingCodeSuggestion)}
        errorMessage={helperInErrorState(callingCodeHelper) ? (callingCodeHelper.text as string) : undefined}
      />
    </GridColumn>
  );
});

export default CountryCallingCode;
